// base
import { date } from '@/helper/locale/base/base_date.th.js';
import { button } from '@/helper/locale/base/base_button.th.js';
// module
import { iimmpact } from '@/module/Iimmpact/locale/iimmpact.th';

export const th = {
    // base
    date: date,
    button: button,
    // module

    iimmpact: iimmpact,
};
